const Login = () => import('@/components/auth/Login.vue')
const SignUp = () => import('@/components/auth/SignUp.vue')
const SignUpPymes = () => import('@/components/auth/SingUpPymes.vue')
const SignUpSuccess = () => import('@/components/auth/SignUpSuccess.vue')
const ResetPassword = () => import('@/components/auth/ResetPassword.vue')
const SetPassword = () => import('@/components/auth/SetPassword.vue')
const ValidateEmail = () => import('@/components/auth/ValidateEmail.vue')
// Collection FI
const CollectionLogin = () => import('@/components/auth/collection/Login.vue')
const CollectionSignUp = () => import('@/components/auth/collection/SignUp.vue')
const ValidateRegisterInfoUser = () => import('@/components/auth/FinalRegisterUser.vue')


export const userAccessRoutes = [
  { path: '/login', component: Login, meta: { requiresLogout: true } },
  { path: '/validate-email', component: ValidateEmail, meta: { breadcrumb: '' } },
  { path: '/signup', component: SignUp, meta: { breadcrumb: '' } },
  { path: '/signup-pymes', component: SignUpPymes, props: route => ({ query: route.query.packageId}) },
  { path: '/collection-login', component: CollectionLogin, meta: { breadcrumb: '' } }, // Cobranzas FI
  { path: '/collection-signup', component: CollectionSignUp, meta: { breadcrumb: '' } }, // Cobranzas FI
  { path: '/checkout-session/success', component: SignUpSuccess, meta: { breadcrumb: '' } },
  { path: '/reset-password', component: ResetPassword, meta: { breadcrumb: '' } },
  { path: '/set-password', component: SetPassword, props: route => ({ query: route.query.token }) },
  { path: '/validateInformation', component: ValidateRegisterInfoUser },
]
